import { AppstoreAddOutlined, SettingOutlined } from '@ant-design/icons';
import { DarwinMenu } from 'components/darwin-ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getItem } from './menuUtils';
import { useUI, SelectedMenu } from 'contexts/UiContext';
import { ROUTES } from 'routes/routes';
import { MenuItem, SETTINGS_MENU } from 'routes/settings.config';
import { usePermissionChecker } from 'hooks/usePermissionChecker';

export const SideMenu = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    setSelectedMenu,
    setSelectedSettingMenu,
    selectedMenu,
    selectedSettingsMenu,
  } = useUI();

  const checkPermission = usePermissionChecker();

  const settingItems = SETTINGS_MENU.flatMap(item => {
    const [module, action] = item.permission;
    const allowed = checkPermission(module, action);

    if (!allowed) return [];

    return getItem({
      label: t(item.labelKey),
      key: item.key,
      onClick: () => {
        navigate(item.route);
        setSelectedSettingMenu(item.key as MenuItem);
      },
    });
  });

  const menuItems = [
    getItem({
      label: t('home'),
      key: SelectedMenu.HOME,
      icon: <AppstoreAddOutlined className="menu-icon" />,
      onClick: () => {
        navigate(ROUTES.HOME);
        setSelectedMenu(SelectedMenu.HOME);
      },
    }),
    ...(settingItems.length
      ? [
          getItem({
            label: t('settings'),
            key: SelectedMenu.SETTINGS,
            icon: <SettingOutlined className="menu-icon" />,
            children: settingItems,
            onClick: () => setSelectedMenu(SelectedMenu.SETTINGS),
          }),
        ]
      : []),
  ];

  return (
    <DarwinMenu
      theme="dark"
      mode="inline"
      items={menuItems}
      selectedKeys={[selectedMenu, selectedSettingsMenu]}
      defaultOpenKeys={[SelectedMenu.SETTINGS]}
      defaultSelectedKeys={[SelectedMenu.HOME]}
    />
  );
};
